import { RenderFunc } from '../types/RenderFunc';

export const renderPetitionOrganizationType: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue: String(oldValue) === '1' ? 'Контролируемое лицо' : 'Учредитель',
    renderedNewValue: String(newValue) === '1' ? 'Контролируемое лицо' : 'Учредитель',
  };
};
